import { SWPaywallRecordType, paywallId } from "../records";
export const ensurePaywall = (store)=>{
    if (!store.has(paywallId)) {
        store.put([
            SWPaywallRecordType.create({
                id: paywallId,
                version: 0,
                editable: true
            })
        ]);
    }
};
